import apiClient from '../utils/apiClient';

const normalizeTreksPayload = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.treks)) return payload.treks;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
};

export const fetchTreks = async () => {
    const response = await apiClient.get('/treks');
    return normalizeTreksPayload(response?.data);
};

let batchPriceQueue = [];
let batchPriceTimer = null;

export const fetchBatchPrice = async (trekId) => {
    return new Promise((resolve) => {
        batchPriceQueue.push({ trekId, resolve });
        if (!batchPriceTimer) {
            batchPriceTimer = setTimeout(async () => {
                const queue = batchPriceQueue;
                batchPriceQueue = [];
                batchPriceTimer = null;
                const ids = [...new Set(queue.map(q => q.trekId))];
                try {
                    const res = await apiClient.get(`/trek-prices/batch?ids=${ids.join(',')}`);
                    const priceMap = res.data?.data || {};
                    queue.forEach(q => resolve(q.resolve(priceMap[q.trekId] || null)));
                } catch {
                    queue.forEach(q => resolve(q.resolve(null)));
                }
            }, 50);
        }
    });
};
